import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import Icons from "../svg/Icons.ts";
import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.js";

import theModalTpl from "./file-viewer.mustache";
import $ from "../$.js";

var modalViewFile;

Html.register({
  async fileview(after){
    var 
      file = FwDatas.getIMedia(this.metaId()),
      group = this.attr('data-media-viewer-group'),
      groupNodes = Array.from($(`[data-media-viewer-group="${group}"]`)),
      groupFiles = groupNodes.map(node=>FwDatas.getIMedia($(node).metaId())),
      index = groupFiles.indexOf(file);
    
    if(!file) {
      return;
    }
    //check premium rights if it is not an image  
    if(!file.isImage()){
      let state = FwDatas.getState()
      if(file.isAudio()){
        if(!state.premium.audio){
          Html.trigger(this,'takepremium');
          return;
        }  
      } else if(file.isVideo()){
        if(!state.premium.videoAvailable){
          Html.trigger(this,'takepremium');
          return;
        }
      } else if(FwDatas.getPermission('filer')!=='OK'){
        Html.trigger(this,'takepremium');
        return;
      }
    }
    
    modalViewFile = modal.openModal(theModalTpl,{
      prev:groupFiles[index-1],
      next:groupFiles[index+1],
      file
    });
    modalViewFile.find('img.main-image').each((idx,node)=>{
      $(node).on('load',function(){
        node.style.border="20px solid white";
        node.nextSibling.parentNode.removeChild(node.nextSibling)
      })
    });
    if(after==='print'){
      modalViewFile.find('img').each((idx,node)=>{
        $(node).on('load',function(){
          window.print();
        })
      });
      //ca marche pas parceque c'est pas le bon domaine
      /*
      modalViewFile.find('iframe').each((idx,node)=>{
        node.onload = function(){
          node.contentWindow.print();
        }
      })*/
    }
    modalViewFile.on('click','[navigation]',function(event){
      event.stopPropagation();
      index += parseInt(event.currentTarget.getAttribute('navigation'));
      modal.closeModal(modalViewFile);
      $(groupNodes[index]).trigger('click')
    })  
  },
  filedownload(){
    const file = FwDatas.getIMedia(this.metaId());
    window.open(file.pictureUrl+'&download');
  },
  async filesend(){
    try{
      const
      file = FwDatas.getIMedia(this.metaId()),
      blob =  await fetch(file.pictureUrl).then(r => r.blob());
    return await navigator.share({
       text:file.name,
       files:[new File([blob],file.name,
       {type:file.mimeType})]
     })
    }catch(e){
      modal.oops('fw2.defaultError')
    }
  },
  filedelete(){
    const 
      file = FwDatas.getIMedia(this.metaId());

    modal.confirmDelete('files.confirmdeletefile',async ()=>{
      await ApiServer.filerdeletefile(file.metaId).then(()=>{
        modal.toastDone('files.toastfiledeleted',file)
      })
      //for closing the file viewer
      modal.closeModal();
      amplify.publish('mediaDeleted',file.metaId);
    })
  },
  
});
actionMenu.register({
  filemenu(){
    const 
      file = FwDatas.getIMedia(this.metaId()),
      buttons = [];
    if(file.parentFolderId){
      if(file.rights.canUpdate){
        buttons.push({onclick:'fileedit',svg:Icons.ic_edit,i18nkey:'actions.rename'})
        buttons.push({onclick:'filemove',svg:Icons.filer.ic_file_move,i18nkey:'actions.move'})
      }
      buttons.push({onclick:'fileduplicate',svg:Icons.ic_duplicate,i18nkey:'actions.duplicate'})
    }
    buttons.push({onclick:'filedownload',svg:Icons.ic_download,i18nkey:'actions.download'})
    buttons.push({onclick:'filesend',svg:Icons.ic_send,i18nkey:'actions.send'})
    
    if(file.isImage()){
      if(modalViewFile && modalViewFile.get(0).parentNode){
        buttons.push({onclick:'print',svg:Icons.ic_print,i18nkey:'actions.print'})
      }else{
        buttons.push({onclick:'fileview|print',svg:Icons.ic_print,i18nkey:'actions.print'})
      }
    }
    
    if(file.rights.canDelete){
      buttons.push({onclick:'filedelete',svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'})
    } 
    
    return {'menu':buttons}
  }

})
function close(){
  modal.closeModal(modalViewFile);
}

export {close}